module.exports = __webpack_public_path__ + "static/img/7.072d0bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/7.png
// module id = vcwA
// module chunks = 0